import BaseClient from '../base/baseClient';
import endpoint from '../../features/endPoints/ecommEndpoints';

export const LoginUserClient = async (requestBody) => {
  const { post: postClient } = BaseClient();
  try {
    return await postClient(process.env.REACT_APP_ECOMM_URL+endpoint.login(), requestBody, {}, false);
  } catch(error) {
    return { error: 'Some error occured. Please try again' };
    
  }
};

export const LoginAdminClient = async (token) => {
  const requestBody = { 
    'username': '',
    'password': '',
    'customToken': token
   };
  const { post: postClient } = BaseClient();
  try {
    return await postClient(process.env.REACT_APP_ECOMM_URL+endpoint.login(), requestBody, {}, false);
  } catch(error) {
    return { error: 'Some error occured. Please try again' };
  }
};
